<template>
  <div class="devOps_producerSpaceSet">
    <el-form ref="form" class="form_warp" inline size="mini" :model="form" label-width="100px" style="margin-top: 10px;">
      <el-form-item label="用户">
        <el-input :style="iptStyle" placeholder="请输入"  v-model="form.name" />
      </el-form-item>
      <el-form-item label="部门">
        <el-input :style="iptStyle" placeholder="请输入"  v-model="form.deptName" />
      </el-form-item>
      <el-form-item label="角色">
        <el-select size="mini" autocomplete="off" v-model="form.roleId" collapse-tags filterable multiple placeholder="请选择角色">
          <el-option v-for="(item, index) in allRoles" :key="index" :label="item"
                     :value="index" ></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="状态">
        <el-select size="mini" autocomplete="off" v-model="form.status" collapse-tags filterable placeholder="请选择状态">
          <el-option v-for="(key, value) in allStatus" :key="key" :label="key" :value="value">
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item>
        <el-button  style="margin-left:32px;letter-spacing: 2px;font-weight: bold;font-size: 12px;" type="primary" @click="formSearch('reset','search')" v-if="menu && menu.btn_user_query">查询
        </el-button>
      </el-form-item>
    </el-form>
    <div style="height: 65vh">
  <el-table height="100%" :header-cell-style="getCellClass" row-key="id" ref="multipleTable" style="margin-top:0;" :cell-style="getRowClass" :data="tableData">
    <el-table-column prop="id" label="用户编码" width="80" :show-overflow-tooltip="true"></el-table-column>
    <el-table-column prop="nameZh" label="中文名" width="80" :show-overflow-tooltip="true"></el-table-column>
    <el-table-column prop="nameEn" label="英文名" width="120"  :show-overflow-tooltip="true"></el-table-column>
    <el-table-column prop="empCode" label="工号" width="120" :show-overflow-tooltip="true"></el-table-column>
    <el-table-column prop="deptName" label="部门" width="120" :show-overflow-tooltip="true"></el-table-column>
    <el-table-column prop="role" label="角色"  width="120" :show-overflow-tooltip="true"></el-table-column>
    <el-table-column prop="statusDesc" label="状态" width="80"  :show-overflow-tooltip="true"></el-table-column>
    <el-table-column prop="email" label="邮箱" min-width="160" :show-overflow-tooltip="true"></el-table-column>
    <el-table-column fixed="right" label="操作">
      <template slot-scope="scope">
        <div style="display: flex;">
          <el-button v-if="menu.btn_user_edit" type="primary" round size="mini" @click="showDialogVisible('updateUser', scope.row)">修改</el-button>
<!--
          <el-button type="danger" round size="mini" @click.stop="onDeleteUser(scope.row.id)">删除</el-button>
-->

        </div>
      </template>
    </el-table-column>
  </el-table>
    </div>
    <div class="block devOpsSpace_page">
      <el-pagination background @size-change="handleSizeChange" @current-change="handleCurrentChange"
                     :current-page.sync="currentPage" :page-size="pageSize" :page-sizes="[10, 25, 50, 100]"
                     layout="total, prev, pager, next, sizes" :total="total">
      </el-pagination>
    </div>
    <UpdateUser  v-if="dialogVisible.updateUser" :dialogVisible='dialogVisible.updateUser' :hideDialogVisible="hideDialogVisible" :formInfo="checkedInfo"></UpdateUser>
  </div>
</template>

<script>
import {mapState} from "vuex";
import {
  getDevOpsSpaceUserManageListApi, getDevOpsSpaceUserRoleListApi,
  postDevOpsSpaceDeleteProjectCommentApi,
  postDevOpsSpaceDleteUserApi
} from "@/server/tops/devOps";
import UpdateUser from "@/views/tops/devOps/settingSpace/components/config/updateUser.vue";
import {getDevOpsSpaceMenuListListApi} from "@/server/tops/base";
export default {
  components: {UpdateUser },
  data() {
    return {
      tableData: [],
      searchData: [],
      form:{
        user:'',
        status:'1',
        roleId:[],
      },
      dialogVisible:{
        updateUser: false,
      },
      checkedInfo:{},
      currentPage: 1,
      pageSize:10,
      total:0,
      // input 搜索样式
      iptStyle: {
        width: '180px'
      },
      allStatus:{'0':'无效','1':'有效','2':'全部'},
      menu:{},
      allRoles: [],
    }
  },
  async created() {
    await this.getAuth();
    await this.getNewData();
    await this.getUserRoleList();
  },
  computed: {
    ...mapState(
        {
          allSelect: (state) => state.devOps.ALLSELECT,
          allMenuList: (state) => state.devOps.ALLMENULIST,
        }
    ),
  },
  methods: {
    getCellClass(row, column, rowIndex, columnIndex) {
      return "padding: 4px 0;height:36px;background:#7F7F7F;color:#fff;font-size:14px;"
    },
    // 表格样式
    getRowClass({ row, column, rowIndex, columnIndex }) {
      if(columnIndex == 0 || columnIndex == 1){
        return "border:none;border-top:1px solid #EBEEF5;font-size: 12px;font-weight: bold;padding:6px 0;";
      }
      return "border:none;border-top:1px solid #EBEEF5;font-size: 12px;padding:6px 0;";
    },
    async getNewData(){
      let params = {}
      params.pageNo = this.currentPage
      params.pageSize = this.pageSize
      params.name = this.form.name;
      params.deptName = this.form.deptName;
      params.status = this.form.status;
      params.roleId = this.form.roleId.toString();

      getDevOpsSpaceUserManageListApi(params).then((res)=>{
        this.tableData = res.data;
        this.total = res.count;
      })
    },
    onDeleteUser(id){
      this.$confirm("此操作将删除该用户, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(async () => {
        postDevOpsSpaceDleteUserApi({id:id}).then(async (ret) => {
          if (ret.status === 'success') {
            this.$notify({
              message: ret.message || '删除成功',
              type: "success",
            })
            await this.getNewData();
          } else {
            this.$notify({
              message: ret.message || "失败",
              type: "error",
            })
          }
        })
      });
    },
    // 弹出模板
    async showDialogVisible(type, row) {
      this.dialogVisible[type] = true;
      this.checkedInfo = row;
    },
    async hideDialogVisible(nextStep = '', search = true) {
      for (let key in this.dialogVisible) {
        this.dialogVisible[key] = false;
      }
      await this.getNewData();
    },
    formSearch(){
      let newTableData = [];
      this.currentPage = 1;
      this.getNewData();
    },
    handleSizeChange(val) {
      this.pageSize = val
      this.currentPage = 1;
      this.getNewData();
    },
    handleCurrentChange(val) {
      this.getNewData();
      //this.currentPage = val
    },
    async getAuth() {
      let menu = {}
      await getDevOpsSpaceMenuListListApi().then((res) => {
        res.data.btnList.forEach((item) => {
            menu[item.code] = 1;
        })
      })
      this.menu = menu;
    },
    async getUserRoleList(){
      let arr = {};
      await  getDevOpsSpaceUserRoleListApi().then((ret)=>{
        ret.data.forEach((item)=>{
          arr[item.id] = item.name;
        })
      })
      this.allRoles = arr;
    },
  }
}
</script>
<style lang="scss">
.devOps_producerSpaceSet{
  .devOpsSpace_page {
    // text-align: right;
    display: flex;
    justify-content: flex-end;
    margin-right: 20px;

    .demonstration {
      font-size: 13px;
      color: #606266;
      line-height: 1;
      margin-top: 25px;
      margin-right: 10px;
    }
  }
  .el-form-item__label {
    font-weight: bold;
    font-size: 12px;
  }
}
.el-message-box__wrapper {
  bottom: initial !important;
  top:10%;
}
</style>
